import React from 'react';
import MetaTags from '../components/MetaTags';
import AuditionCategoryRow from '../components/AuditionCategoryRow';
import JourneyCTA from '../components/JourneyCTA';
import InstantAIScoring from '../components/InstantAIScoring';
import AuditionTypes from '../components/AuditionTypes';

import '../App.css'; // Your main app styles
import BannerSlider from '../components/BannerSlider';

const HomePage = () => {
 const pageMeta = {
    title: "Home - BookMyAudition",
    description: "Find the latest acting auditions in India. Connect with casting directors for Bollywood, TV serials, ad films, and web series.",
    imageUrl: "https://bma.on.joget.cloud/jw/web/app/bookmyaudition/resources/bma_logo.png", // Optional: if different from default
    url: "http://localhost:3000/" // Optional: if different from default
  };
  return (
    <> {/* Using Fragment shorthand */}
      <MetaTags
        title={pageMeta.title}
        description={pageMeta.description}
      />
      <main className="main-container-custom">
        <BannerSlider />

        <AuditionCategoryRow/>

        <InstantAIScoring />
        <AuditionTypes />
        <JourneyCTA />
      </main>
      {/* <FooterComponent /> */}
    </>
  );
};

export default HomePage;